import React from 'react';
import { IconName, PopUp } from 'goalsetter-webapp-components';
import { useTranslation } from 'react-i18next';

interface SimpleModalProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  description: string;
}

const SimpleModal: React.FC<SimpleModalProps> = ({
  show,
  onClose,
  description,
  title,
}) => {
  const { t } = useTranslation();
  return (
    <PopUp
      isVisible={show}
      icon={IconName.ATTENTION}
      iconSize={80}
      title={title ? title : String(t('uhOh'))}
      description={description}
      buttonPrimaryTitle={String(t('gotIt'))}
      onPressPrimary={onClose}
      onClose={onClose}
    />
  );
};

export default SimpleModal;
